import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/PublicNav";

export default function Reset() {
  const { token } = useParams();
  const { resetPassword } = useAuth();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 10) { setError("Password needs at least 10 characters."); return; }
    setLoading(true);
    const res = await resetPassword(token, password);
    setLoading(false);
    if (res.ok) nav("/app"); else setError(res.error);
  };

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-sm space-y-4">
        <Logo />
        <form onSubmit={submit} className="dk-card p-8 space-y-4" data-testid="reset-form">
          <h1 className="font-serif text-[24px] font-semibold">Choose a new password</h1>
          {error && <div className="rounded-xl p-3 text-sm" style={{ background: "#F3DEDA", color: "var(--error)" }} data-testid="reset-error">{error}</div>}
          <input className="dk-input" type="password" placeholder="New password (min 10 characters)" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" />
          <button className="btn btn-primary w-full" disabled={loading} data-testid="reset-submit">{loading && <Loader2 size={16} className="animate-spin" />} Set new password</button>
          <p className="text-sm text-center"><Link className="link" to="/auth/login">Back to log in</Link></p>
        </form>
      </div>
    </div>
  );
}
